 (function(){
   	$(document).ready ( function(){
      	var url_string = window.location.href;
        var url = new URL(url_string);
      	var imgid = url.searchParams.get("id");
      	var resp_id = url.searchParams.get("resp_id");
      	if(imgid != null){
          $('#selfie_img').attr('src', 'https://s.tangent.ai/user-image/mango/'+imgid);
        } 
        if(resp_id != null){
        	var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+resp_id;
          	$.ajax(checkout_url, {
              success: function(data) {
                if(data.selfie_url!=null && data.selfie_url!=undefined){
                  $('#selfie_img').attr('src', data.selfie_url);
                }
                var products = data.products;
                var allToCart = "https://www.amazingcosmetics.com/cart/add?id[]=";
                if(products.length>0){
                  var bootClassName = "col-lg-4";
                  switch(products.length) {
                    case 1:bootClassName = "col-lg-4";
                      break;
                    case 2:
                      bootClassName = "col-lg-6";
                      break;
                    case 3:
                      bootClassName = "col-lg-4";
                      break;
                    default:
                      bootClassName = "col-lg-3";
                      // code block
                  }
                  $("#add-all-to-cart").show();
                  
                  for(var p=0;p<products.length;p++){
                    if(p==0){
                      allToCart = allToCart + products[p].variants[0].id;
                    }
                    else{
                      allToCart = allToCart + '&id[]='+products[p].variants[0].id;
                    }

                    $('#add-all-to-cart').attr('href', allToCart);
                    $('#products-section-checkout').append('<div class="'+bootClassName+' col-12"><a class="text-link" target="_blank" href="https://www.amazingcosmetics.com/products/'+products[p].handle+'"><img class="tangent-product-img" src="'+products[p].images[0].src+'" ><p class="product-title"><b>'+products[p].title+'</b></p><p class="tangent-product-price">$'+products[p].variants[0].price+'</p></a><div id="product_'+p+'"></div><p><a id="'+products[p].variants[0].id+'" class="tangent-btn-add" onclick="addToCart('+products[p].variants[0].id+')">Add to Cart</a></p><div/>');
                  
                  }
                  
                  if(products.length==1){
                    $('#products-section-checkout').prepend('<div class="col-lg-4"></div>');
                    $('#products-section-checkout').append('<div class="col-lg-4"></div>');
                  }
                }
              
                if(data.description!=''){
                  $(".general-text").hide();
                  $("#checkout-description").show();
                  $("#checkout-description" ).html( data.description );
                }
            },
            error: function() {
              console.log("Error in server call");
            }
          });
        }
    });   
})();
  
  
function addToCart(pid){
  Shopify.addItem(pid, 1, function(event){
  });
  $("#"+pid).text("Added to Cart!");
  $("#"+pid).css({
    "background-color": "#56565b",
    "cursor"     : "none",
    "pointer-events": "none"
  });

}